
//@ts-expect-error
export const BASE_URL = window.ENV?.REACT_APP_LOGINURL ?? '';
//@ts-expect-error
const API_BASE_URL = window.ENV?.REACT_APP_BASE_API ?? '';
export const TOKEN_URL_GUEST = API_BASE_URL + '/auth/generate-client-credential-token';
export const TOKEN_URL = API_BASE_URL + '/auth/authorize';
export const SESSION_REQUEST_CONFIG = { withCredentials: true };
//@ts-expect-error  undefined
export const CLIENT_ID = window.ENV?.CLIENT_ID || 'NO-CLIENT';
export const REDIRECT_URL = window.location.origin + '/authorize';
//@ts-expect-error
export const LOGOUT_SLO_URL = window.ENV?.REACT_APP_LOGOUT_SLO_URL 
//@ts-expect-error
export const SCOPE = window.ENV?.SCOPE ?? '';
//@ts-expect-error
export const GRANT_TYPE = window.ENV?.GRANT_TYPE ?? '';
export const loginurl = `${ BASE_URL }?response_type=code&grant_type=${ GRANT_TYPE }&client_id=${ CLIENT_ID }&scope=${ SCOPE }&redirect_uri=${ REDIRECT_URL }`;
//@ts-expect-error
export const SESSION_INACTIVE_TIMER = window.ENV?.SESSION_INACTIVE_TIMER

